/**
 * @generated SignedSource<<3c44351ed88bf21b0fa49440b1dbae20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContemporaryLandingProductsModule_contemporaryLandingRow$data = {
  readonly items: ReadonlyArray<{
    readonly items?: ReadonlyArray<{
      readonly brand?: string | null;
      readonly contemporaryTrackingString?: string | null;
      readonly imagePath?: string | null;
      readonly itemPk?: string | null;
      readonly link?: string | null;
      readonly netPrice?: string | null;
      readonly retailPrice?: string | null;
      readonly title?: string | null;
    } | null> | null;
    readonly text?: string | null;
    readonly type?: string | null;
  } | null> | null;
  readonly " $fragmentType": "ContemporaryLandingProductsModule_contemporaryLandingRow";
};
export type ContemporaryLandingProductsModule_contemporaryLandingRow$key = {
  readonly " $data"?: ContemporaryLandingProductsModule_contemporaryLandingRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContemporaryLandingProductsModule_contemporaryLandingRow">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContemporaryLandingProductsModule_contemporaryLandingRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "type": "ContemporaryLandingHeader",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "brand",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contemporaryTrackingString",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "imagePath",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "itemPk",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "link",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "netPrice",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "retailPrice",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    }
                  ],
                  "type": "ContemporaryLandingProductRowItem",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "type": "ContemporaryLandingRow",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContemporaryLandingRow",
  "abstractKey": null
};
})();

(node as any).hash = "110f5f7307430638050a46e8cdd082f3";

export default node;
